var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpotify = function SvgSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#3b4c6a",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.464 14.185c-5.157-3.063-13.664-3.344-18.588-1.85a1.496 1.496 0 1 1-.869-2.864c5.652-1.716 15.047-1.384 20.985 2.14a1.496 1.496 0 0 1-1.528 2.574m-.169 4.537a1.25 1.25 0 0 1-1.716.41c-4.3-2.643-10.856-3.408-15.943-1.864a1.25 1.25 0 0 1-1.557-.831 1.25 1.25 0 0 1 .832-1.556c5.811-1.763 13.036-.91 17.974 2.126.586.36.771 1.129.41 1.715m-1.957 4.356a.997.997 0 0 1-1.372.332c-3.757-2.296-8.486-2.815-14.055-1.543a.996.996 0 1 1-.444-1.943c6.095-1.393 11.322-.794 15.54 1.783a.997.997 0 0 1 .33 1.371Z"
  })));
};
export default SvgSpotify;